import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiTool, FiMonitor, FiRepeat } = FiIcons;

const features = [
  {
    icon: FiTool,
    title: 'Hands-On Campus Labs',
    text: 'Practice with tools, meters, electrical components, refrigeration equipment, air conditioning systems, and mechanical assemblies in a supervised lab environment.',
  },
  {
    icon: FiMonitor,
    title: 'Flexible Online Foundations',
    text: 'Learn HVAC terminology, safety procedures, thermodynamics, refrigeration cycles, electrical theory, and basic system operation around a work or family schedule.',
  },
  {
    icon: FiRepeat,
    title: 'Hybrid Career Preparation',
    text: 'Combine online coursework with in-person practice, troubleshooting exercises, and instructor guidance so technical concepts translate into job-ready skills.',
  },
];

function FeatureGrid() {
  return (
    <section className="choose-section">
      <div className="section contained">
        <div className="section-heading">
          <p className="eyebrow">What to look for</p>
          <h2>Choose Training That Builds Real Technical Confidence</h2>
          <p>
            The most useful HVAC education connects theory to practice.
            Students should have opportunities to read wiring diagrams, use
            diagnostic instruments, identify system components, follow
            manufacturer procedures, and explain repair decisions clearly.
          </p>
        </div>

        <div className="feature-grid">
          {features.map((feature, index) => (
            <article
              className={`feature-card feature-${index + 1}`}
              key={feature.title}
            >
              <SafeIcon icon={feature.icon} />
              <h3>{feature.title}</h3>
              <p>{feature.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FeatureGrid;